<mat-card
  appearance="outlined"
  class="admin-settings-setting"
  [ngClass]="{'edit': editing}"
>
  <mat-card-header class="admin-settings-setting__header">
    <mat-card-title>
      {{setting.name}}
    </mat-card-title>

    @if (!editing) {
      <button
        mat-button
        class="admin-settings-setting__edit-button"
        (click)="editSetting()"
      >
        <i class="icon-edit-alternative"></i>

        <span class="bold">
          {{ 'TRANS__ADMIN_SETTINGS__EDIT' | translate }}
        </span>
      </button>
    }

    <mat-card-subtitle>
      {{setting.description}}
    </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content class="admin-settings-setting__content">
    @for (subSetting of setting.sub_settings; track $index) {
      <div class="admin-settings-setting__content-item">
        <app-admin-settings-field-value
          [subSetting]="subSetting"
          [editing]="editing"
        ></app-admin-settings-field-value>
      </div>
    }
  </mat-card-content>

  @if (editing) {
    <hr>

    <mat-card-actions
      align="end"
      class="admin-settings-setting__buttons"
    >
      <button
        mat-flat-button
        color="accent"
        class="bold"
        (click)="storeSetting()"
        [disabled]="storing"
      >
        <span>
          {{ 'TRANS__ADMIN_SETTINGS__ACTIONS__STORE' | translate }}
        </span>
      </button>

      <button
        mat-button
        color="accent"
        class="bold"
        (click)="cancelSetting()"
        [disabled]="storing"
      >
        <span>
          {{ 'TRANS__ADMIN_SETTINGS__ACTIONS__CANCEL' | translate }}
        </span>
      </button>
    </mat-card-actions>
  }

  <mat-card-footer class="admin-settings-setting__footer">
    @if (error) {
      <span>
        {{ error | translate }}
      </span>
    }
  </mat-card-footer>
</mat-card>
